var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.742,
    height: 23.742,
    viewBox: "0 0 23.742 23.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-google_1_",
    "data-name": "icons8-google (1)",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M27.511,13.546h-.956V13.5H15.871v4.748H22.58A7.128,7.128,0,1,1,20.6,10.552l3.358-3.358a11.859,11.859,0,1,0,3.788,8.677A11.952,11.952,0,0,0,27.511,13.546Z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10331",
    "data-name": "Path 10331",
    d: "M6.306,10.346l3.9,2.86a7.108,7.108,0,0,1,11.327-2.654l3.358-3.358A11.848,11.848,0,0,0,6.306,10.346Z",
    transform: "translate(-0.937)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10332",
    "data-name": "Path 10332",
    d: "M16.763,37.519a11.816,11.816,0,0,0,7.959-3.082l-3.674-3.109a7.1,7.1,0,0,1-10.982-3.274L6.2,31.037A11.862,11.862,0,0,0,16.763,37.519Z",
    transform: "translate(-0.892 -9.777)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10333",
    "data-name": "Path 10333",
    d: "M35.64,20.049h-.956V20H24v4.748h6.709a7.147,7.147,0,0,1-2.426,3.307h0l3.674,3.109a11.483,11.483,0,0,0,3.912-8.789A11.952,11.952,0,0,0,35.64,20.049Z",
    transform: "translate(-8.129 -6.503)",
    fill: "#1976d2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.12bf63d8f02099a9148b3b75762d80d6.svg";
export { ForwardRef as ReactComponent };